import { combineReducers } from "redux";
import { localStorage as localStorageReducer } from "reducers/localStorage";
import { config } from "reducers/config";
import { security } from "reducers/security";
import { user } from "reducers/user";
import { urls } from "reducers/urls";
import { categories } from "reducers/categories";
import { window as windowReducer } from "reducers/window";
import { error } from "reducers/error";
import { pages } from "reducers/pages";
import { game } from "reducers/game";
import { games } from "reducers/games";
import { filters } from "reducers/filters";
import { recommendedRoutes } from "reducers/recommended";
import { links } from "reducers/links";
import { application } from "reducers/application";
import { cookie } from "reducers/cookie";
import { profile } from "reducers/profile";
import { betHistory } from "reducers/betHistory";
import { tournaments } from "reducers/tournament";
import { router, modalHistory } from "reducers/history";
import { search } from "reducers/search";
import { serverSentEvent } from "reducers/severtSentEvents";
import { theme } from "reducers/theme";
import { historyLinks } from "reducers/roundHistoryLinks";

// Each `reducers/*.js` module also exports its own `defaultValue` alongside its reducer(s).
// The previous `Object.assign(...)`/spread-of-namespace-import merge pulled those in too
// (harmlessly at runtime — redux's own `combineReducers` filters out non-function values before
// building the state map, so `defaultValue` was silently dropped), but redux's *type-level*
// `combineReducers<M>` has no equivalent filter: it conditionally resolves to `never` the moment
// any value in `M` isn't reducer-shaped, which collapsed `RootState` (src/store/types.ts) to an
// untyped `any`. Importing each reducer function by name — never the module's `* as` namespace —
// keeps the object passed to `combineReducers` reducer-only, so TypeScript can infer real keys.
export default combineReducers({
  localStorage: localStorageReducer,
  config,
  security,
  urls,
  user,
  categories,
  window: windowReducer,
  error,
  pages,
  game,
  games,
  filters,
  recommendedRoutes,
  links,
  application,
  cookie,
  profile,
  betHistory,
  tournaments,
  router,
  modalHistory,
  search,
  serverSentEvent,
  theme,
  historyLinks,
});
